/**
 * URL pattern utilities for detecting and parsing short URLs.
 */

const SHORT_URL_PATTERN =
  /^\/([a-z0-9]{2})\/([123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{8})\/?$/;

export interface ShortUrlParts {
  appShortCode: string;
  shortCode: string;
}

/**
 * Detect if current path is a short URL.
 * Pattern: /:appShortCode/:shortCode
 * Example: /dd/K7Bp9xZa
 */
export function isShortUrl(pathname: string): boolean {
  return SHORT_URL_PATTERN.test(pathname);
}

/**
 * Parse short URL into components.
 * @returns ShortUrlParts or null if not a valid short URL
 */
export function parseShortUrl(pathname: string): ShortUrlParts | null {
  const match = pathname.match(SHORT_URL_PATTERN);
  if (!match) return null;

  return {
    appShortCode: match[1],
    shortCode: match[2],
  };
}

/**
 * Check if current URL is a standard checkout URL.
 * Pattern: /checkout?pi=...&token=...
 */
export function isCheckoutUrl(pathname: string): boolean {
  return pathname === '/checkout' || pathname === '/checkout/' || pathname === '/';
}
